// extracted by mini-css-extract-plugin
module.exports = {"hop-Label":"Label_hop-Label__qcMbg"};